import { render, staticRenderFns } from "./ClerkAccountManagemen.vue?vue&type=template&id=476e3328&scoped=true&"
import script from "./ClerkAccountManagemen.vue?vue&type=script&lang=js&"
export * from "./ClerkAccountManagemen.vue?vue&type=script&lang=js&"
import style0 from "./ClerkAccountManagemen.vue?vue&type=style&index=0&id=476e3328&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476e3328",
  null
  
)

export default component.exports